export function objectToFormData(obj, formData = new FormData(), parentKey = '') {
  if (obj === null || obj === undefined) return formData

  if (obj instanceof File || obj instanceof Blob) {
    formData.append(parentKey, obj)
    return formData
  }

  if (Array.isArray(obj)) {
    obj.forEach((value, index) => {
      const key = `${parentKey}[${index}]`
      objectToFormData(value, formData, key)
    })
    return formData
  }

  if (typeof obj === 'object') {
    Object.keys(obj).forEach(key => {
      const value = obj[key]
      const formKey = parentKey ? `${parentKey}[${key}]` : key
      objectToFormData(value, formData, formKey)
    })
    return formData
  }

  formData.append(parentKey, obj)
  return formData
}